import React from 'react';
import { Textfit } from 'react-textfit';
import { bodyFontSizesBOH, formatDollar, formatDuration, formatPercentage, titleFontSizesBOH, formatGoalValue, isLowerBetter, isHigherBetter, normalizeGoalValue, hasMetricValue, shouldDisplayGoal } from '../../../helpers/utils';
import * as bohLib from '@shift/boh';
import BottomBar from '../../../components/BottomBar';
import './MetricsDashboard.scss';
import TrackChanges from '@material-ui/icons/TrackChanges';
import ArrowUpIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownIcon from '@material-ui/icons/ArrowDownward';
const isFalsyButNotZero = value => value === null || value === undefined || value === '';
const NO_DATA = 'No data';
const MetricsDashboard = ({
  data,
  metadata,
  text
}) => {
  var _metadata$boh_metrics;
  const metricsNames = (_metadata$boh_metrics = metadata === null || metadata === void 0 ? void 0 : metadata.boh_metrics) !== null && _metadata$boh_metrics !== void 0 ? _metadata$boh_metrics : [];
  return /*#__PURE__*/React.createElement("div", {
    className: "Metrics-dashboard-container"
  }, /*#__PURE__*/React.createElement(Header, {
    text: text,
    logo: metadata.logo
  }), /*#__PURE__*/React.createElement(Metrics, {
    metricsNames: metricsNames,
    data: data,
    metadata: metadata,
    text: text
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: metadata.accent_color,
    accent_text_color: text.accent_color,
    hide_poweredbyshift: metadata.hide_poweredbyshift
  }));
};
const Header = ({
  text,
  logo
}) => {
  var _text$title_font_size, _text$body_font_size;
  const titleStyles = {
    color: text.title_color,
    fontFamily: text.title_font_family,
    fontSize: titleFontSizesBOH[(_text$title_font_size = text.title_font_size) !== null && _text$title_font_size !== void 0 ? _text$title_font_size : 'medium']
  };
  const descriptionStyles = {
    color: text.body_color,
    fontSize: bodyFontSizesBOH[(_text$body_font_size = text.body_font_size) !== null && _text$body_font_size !== void 0 ? _text$body_font_size : 'medium']
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: titleStyles
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title-value' + text.title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.medium
  }, text.title)), /*#__PURE__*/React.createElement("p", {
    className: "description",
    style: descriptionStyles
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'description-value' + text.title_font_family,
    mode: "multi",
    min: bodyFontSizesBOH.small,
    max: bodyFontSizesBOH.small
  }, text.body))), logo && /*#__PURE__*/React.createElement("div", {
    className: "logo-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  })));
};
const METRICS_NAME = {
  speed_of_service: 'Speed of service',
  overall_satisfaction: 'Overall satisfaction',
  overall_dissatisfaction: 'Overall dissatisfaction',
  all_complaints_ratio: 'ACR',
  total_employees: 'Total employees',
  average_weekly_sales: 'Avg Weekly Sales',
  training_completion: 'Store Training Completion',
  gm_training_completion: 'GM Training Completion',
  quality_service_cleanliness: 'QSC'
};
const {
  BOH_DEFAULT_GOALS_VALUES: defaultGoals
} = bohLib;
const Metrics = ({
  metricsNames,
  data,
  metadata,
  text
}) => {
  var _metadata$boh_metrics2, _metadata$boh_show_go, _data$data$goals, _data$data, _text$body_font_size2, _text$body_font_size3;
  const titles = (_metadata$boh_metrics2 = metadata === null || metadata === void 0 ? void 0 : metadata.boh_metrics_title) !== null && _metadata$boh_metrics2 !== void 0 ? _metadata$boh_metrics2 : {};
  const showGoals = (_metadata$boh_show_go = metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_goals) !== null && _metadata$boh_show_go !== void 0 ? _metadata$boh_show_go : false;
  const goals = (_data$data$goals = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.goals) !== null && _data$data$goals !== void 0 ? _data$data$goals : {};
  const metrics = metricsNames.map(name => {
    var _data$data2, _goals$name;
    const value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2[name];
    const rawGoal = (_goals$name = goals[name]) !== null && _goals$name !== void 0 ? _goals$name : defaultGoals[`boh.goals.${name}`];
    const normalizedGoal = normalizeGoalValue(rawGoal);
    const hasGoal = showGoals && normalizedGoal !== null;
    const goal = hasGoal ? normalizedGoal : null;
    let percentage = null;
    let isAboveGoal = null;
    const canComputeGoalState = hasGoal && hasMetricValue(value) && goal !== 0;
    if (canComputeGoalState) {
      const higherIsBetter = !isLowerBetter(name) || isHigherBetter(name);
      const delta = higherIsBetter ? value - goal : goal - value;
      percentage = delta / goal * 100;
      isAboveGoal = higherIsBetter ? value >= goal : value <= goal;
    }
    return {
      name: titles[name] || METRICS_NAME[name] || name.replace(/_/g, ' '),
      value,
      key: name,
      goal: canComputeGoalState ? goal : null,
      percentage: canComputeGoalState ? percentage : null,
      isAboveGoal: canComputeGoalState ? isAboveGoal : null
    };
  });
  const cardHeaderStyles = {
    backgroundColor: metadata.accent_color,
    color: text.accent_color,
    fontSize: bodyFontSizesBOH[(_text$body_font_size2 = text.body_font_size) !== null && _text$body_font_size2 !== void 0 ? _text$body_font_size2 : 'medium'],
    width: '100%',
    fontFamily: text.body_font_family
  };
  const cardBodyStyles = {
    color: text.body_color,
    fontSize: bodyFontSizesBOH[(_text$body_font_size3 = text.body_font_size) !== null && _text$body_font_size3 !== void 0 ? _text$body_font_size3 : 'medium'],
    fontFamily: text.body_font_family
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `metrics-grid count-${metricsNames.length}`
  }, metrics.map((metric, index) => /*#__PURE__*/React.createElement("div", {
    key: `${metric.key}-${index}`,
    className: "metric-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "metric-card-header",
    style: cardHeaderStyles
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'metric-name' + text.title_font_family,
    mode: "single",
    min: bodyFontSizesBOH.small,
    max: titleFontSizesBOH.small
  }, metric.name)), /*#__PURE__*/React.createElement("div", {
    className: "metric-card-body",
    style: cardBodyStyles
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'metric-value' + text.title_font_family,
    mode: "single",
    min: bodyFontSizesBOH.small,
    max: titleFontSizesBOH.small
  }, resolveMetricFormat(metric)), shouldDisplayGoal(metric.goal, metric.value) && /*#__PURE__*/React.createElement("div", {
    className: "metric-card-goal-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: `metric-card-goal-badge ${metric.isAboveGoal ? 'above-goal' : 'below-goal'}`
  }, metric.isAboveGoal ? /*#__PURE__*/React.createElement(ArrowUpIcon, {
    className: "metric-card-goal-arrow"
  }) : /*#__PURE__*/React.createElement(ArrowDownIcon, {
    className: "metric-card-goal-arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "metric-card-goal-percentage"
  }, Math.abs(metric.percentage).toFixed(0), "%")), /*#__PURE__*/React.createElement("span", {
    className: "metric-card-goal-text"
  }, metric.isAboveGoal ? 'Above Goal' : 'Below Goal'), /*#__PURE__*/React.createElement("div", {
    className: "metric-card-goal-target"
  }, /*#__PURE__*/React.createElement(TrackChanges, {
    style: {
      fontSize: '22px'
    }
  }), /*#__PURE__*/React.createElement("span", null, "GOAL ", formatGoalValue(metric.goal, metric.key))))))));
};
function resolveMetricFormat(metric) {
  const {
    value,
    key
  } = metric;
  if (isFalsyButNotZero(value)) return NO_DATA;
  switch (key) {
    case 'speed_of_service':
      return formatDuration(value);
    case 'average_weekly_sales':
      return formatDollar(value, 2);
    case 'training_completion':
    case 'gm_training_completion':
      return formatPercentage(value / 100);
    case 'overall_satisfaction':
    case 'overall_dissatisfaction':
    case 'all_complaints_ratio':
    case 'total_employees':
      return value;
    default:
      return value;
  }
}
export default MetricsDashboard;